module.exports = __webpack_public_path__ + "static/media/star-1-green.99796b6a.svg";